import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

export type IconStyle = 'minimalist' | 'high-contrast';

interface ProjectSettings {
  icon_style: IconStyle;
}

export const projectSettingsService = {
  // Get project settings including icon style
  async getProjectSettings(projectId: string): Promise<ProjectSettings | null> {
    try {
      const authSupabase = await getAuthenticatedSupabaseClient();
      const { data, error } = await authSupabase
        .from('projects')
        .select('icon_style')
        .eq('id', projectId)
        .single();

      if (error) {
        logger.error('Error fetching project settings:', error);
        return null;
      }

      return data;
    } catch (error) {
      logger.error('Error in getProjectSettings:', error);
      return null;
    }
  },

  // Update project icon style
  async updateIconStyle(projectId: string, iconStyle: IconStyle): Promise<boolean> {
    try {
      const authSupabase = await getAuthenticatedSupabaseClient();
      const { error } = await authSupabase
        .from('projects')
        .update({ icon_style: iconStyle })
        .eq('id', projectId);

      if (error) {
        logger.error('Error updating icon style:', error);
        return false;
      }

      return true;
    } catch (error) {
      logger.error('Error in updateIconStyle:', error);
      return false;
    }
  },

  // Get project ID from floor plan ID
  async getProjectIdFromFloorPlan(floorPlanId: string): Promise<string | null> {
    try {
      const authSupabase = await getAuthenticatedSupabaseClient();
      const { data, error } = await authSupabase
        .from('floor_plans')
        .select('project_id')
        .eq('id', floorPlanId)
        .single();

      if (error) {
        logger.error('Error fetching project ID:', error);
        return null;
      }

      return data?.project_id || null;
    } catch (error) {
      logger.error('Error in getProjectIdFromFloorPlan:', error);
      return null;
    }
  }
};
